import { createRootRoute,Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

/**
 * Root route — vazio de propósito. Não tem layout aqui (cada subgrupo
 * define o próprio). Apenas <Outlet /> + devtools em dev.
 *
 * Justificativa: queremos que /login NÃO renderize a shell de app
 * (`features/shell`), só o conteúdo do login.
 */
export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
    </>
  ),
});
